module.exports = __webpack_public_path__ + "664bf04224fd8e022ee0170a8b43b5c8.svg";